<div class="delete-confirm-popup">
  <div class="text-color-secondary px-2 pt-5 pb-2" *ngIf="!!confirmMessage">
    {{ confirmMessage | translate : confirmMessageParams }}
    <span class="item-name" *ngIf="itemName">{{ itemName }}</span>
  </div>

  <div class="btn-group">
    <app-base-button
      ngClass="mr-2"
      [label]="submitText"
      (click)="closeDialog('submit')"
    >
    </app-base-button>
    <app-base-button
      ngClass="mr-2"
      [outlined]="true"
      [label]="cancelText"
      (click)="closeDialog('cancel')"
    >
    </app-base-button>
  </div>
</div>
